import * as React from 'react';
import TrackVisibility from 'react-on-screen';
import PageInfo from '../../../common/PageInfo/PageInfo';
import Carousel from '../../../common/Carousel/Carousel';
import flatsImg from '../../../../images/flats.svg';
import houseImg from '../../../../images/house.svg';
import * as styles from './BuildingTypes.module.scss';


const BuildingSlides = [
  {
    title1: 'Apartments',
    subtitle1: 'we will help you',
    subtitle2: 'sell / rent',
    description: 'Flatfy.com leverages technology to provide best-in-class apartment search service in 30 countries around the world.',
    img: flatsImg
  },
  {
    title1: 'Houses',
    subtitle1: 'we will help you',
    subtitle2: 'sell / rent',
    description: 'Flatfy.com aggregates thousands of rental listings from your local real estate agencies and arranges information so you could see your local real estate market as it is.',
    img: houseImg
  }
];

const BuildingTypes = () => (
  <section className={styles.root}>
    <TrackVisibility partialVisibility={true} style={{height: '100%'}}>
      {({ isVisible }) =>
        <div className={styles.containerWrapper}>
          <Carousel slides={BuildingSlides} isVisible={isVisible} page='building_types'/>
          <PageInfo text={'02 - property type'}/>
        </div>
      }
    </TrackVisibility>
  </section>
);

export default BuildingTypes;
